import React from 'react';
import PaymentMethodItem from './PaymentMethodItem';

const PaymentMethodList = ({ paymentMethods, onSetDefault, onDelete }) => {
    const cardItemStyle = {
        borderBottom: '1px solid #e9ecef',
        padding: '15px 0',
        position: 'relative'
    };

    return (
        <div className="mb-4 bg-white rounded-pill">
            <div className="card-body p-0">
                {paymentMethods.length === 0 ? (
                    <p className="text-muted text-center py-4">No payment methods saved yet.</p>
                ) : (
                    paymentMethods.map(method => (
                        <div key={method.id} style={cardItemStyle} className="px-3">
                            <PaymentMethodItem
                                method={method}
                                onSetDefault={() => onSetDefault(method.id)}
                                onDelete={() => onDelete(method.id)}
                            />
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default PaymentMethodList;